// src/pages/SignUpPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import BrandName from '../components/BrandName';
import Seo from '../components/Seo';
import { SIMPLE_PAGES } from '../data/simplePages';
import { webPageJsonLd } from '../data/pageSchema';
import './AuthPages.css';
import './SignUpPage.css';

const seo = SIMPLE_PAGES.find((page) => page.path === '/signup');

const SignUpPage = () => (
  <div className="auth-page">
    <Seo title={seo.title} description={seo.description} path={seo.path} jsonLd={webPageJsonLd(seo)} />
    <div className="signup-choice">
      <div className="auth-logo" style={{textAlign:'center', alignItems:'center'}}><BrandName /></div>
      <h2 style={{textAlign:'center', marginBottom:'8px'}}>Join The Game</h2>
      <p style={{textAlign:'center', color:'var(--muted)', marginBottom:'36px'}}>Choose how you want to use the platform</p>

      <div className="signup-cards">
        <Link to="/customer-signup" className="signup-card">
          <div className="sc-icon">👤</div>
          <h3>I Need a Service</h3>
          <p>Post a job in the browser. Waste carriers are checked against the public register before they&apos;re approved.</p>
          <div className="sc-features">
            <span>✓ Free to post jobs</span>
            <span>✓ Compare bids & ratings</span>
            <span>✓ Live job tracking</span>
          </div>
          <div className="btn btn-primary btn-full" style={{marginTop:'20px'}}>SIGN UP AS CUSTOMER</div>
        </Link>

        <Link to="/provider-signup" className="signup-card signup-card-teal">
          <div className="sc-badge">EARN MORE</div>
          <div className="sc-icon">🚐</div>
          <h3>I'm a Carrier</h3>
          <p>Bid on local jobs, earn Eco Credits and climb the leaderboard.</p>
          <div className="sc-features">
            <span>✓ Find jobs near you</span>
            <span>✓ Earn Eco Credits</span>
            <span>✓ Build your reputation</span>
          </div>
          <div className="btn btn-primary btn-full" style={{marginTop:'20px'}}>SIGN UP AS CARRIER</div>
        </Link>
      </div>

      <p className="auth-footer">Already have an account? <Link to="/login">Log in</Link></p>
    </div>
  </div>
);

export default SignUpPage;
